import qs from 'qs'
import config from '@/api/config'
import { Auth, AppRequire } from '@/api/deviceBridge'
export const appPay = {
	post (url, data, timeOut) {
		if (window.debugFlag) {
			console.log(arguments)
		}
		if (!config.requestCount["urlpay"]) config.requestCount["urlpay"] = 0;

		return new Promise((resolve, reject) => {
			let postData = {
				url: config.paycenter + url,
				body: data || {},
				header: {}
			}
			AppRequire.post(postData).then(httpRequert => {
				if (window.debugFlag) {
					console.log(httpRequert)
				}
				let result = null;
				if (config.responseType == 'json') {
					//判定数据格式
					try {
						JSON.stringify(httpRequert);
						result = httpRequert;
					} catch (e) {
						config.utalkTools.logs("系统故障数据接口返回格式错误" + httpRequert, 'error');
						result = {
							errcode: 9876,
							errmsg: '数据格式错误! 请反馈给技术支持'
						};
					}
					//判定数据状态
					if (result && result.errcode && result.errcode == 1004) {
						if (config.requestCount["urlpay"] < 3) {
							config.requestCount["urlpay"]++;
							return new Promise((resolve, reject) => {
								Auth.login().then(result => {
									resolve(result);
								}).catch(error => {
									reject('设备错误! 要不更新一下软件试试呢!');
									config.utalkTools.logs('设备接口返回错误' + error, 'error');
								});
							}).then(result => {
								return new Promise((resolve, reject) => {
									appPay.post(url, data).then(result => {
										config.requestCount["urlpay"] = 0;
										resolve(result);
									}).catch(error => {
										reject(error);
									});
								});
							}).catch(error => {
								reject(error);
							});
						} else {
							config.requestCount["urlpay"] = 0;
							config.utalkTools.logs('设备接口返回错误 无法刷新登录 获取数据', 'error');
							reject('设备错误! 要不清一下软件缓存试试呢!');
						}
					} else if (result) {
						config.requestCount["urlpay"] = 0;
						resolve(result);
					}
				} else {
					result = httpRequert;
				}
				resolve(result);
			}).catch(error => {
				if (config.requestCount["urlpay"] < 3) {
					config.requestCount["urlpay"]++;
					setTimeout(() => {
						appPay.post(url, data).then(result => {
							config.requestCount["urlpay"] = 0;
							resolve(result);
						}).catch(error => {
							reject(error);
						});
					}, 2000);
				} else {
					config.requestCount["urlpay"] = 0;
					reject('网络信号不佳');
				}
				// config.utalkTools.logs('apprequest 程序捕获异常' + JSON.stringify(error), 'error');
				// reject('网络信号不佳');
			});
		});
	},
	get (url, params = {}, timeOut) {
		if (window.debugFlag) {
			console.log(arguments)
		}
		if (!config.requestCount["urlpayGet"]) config.requestCount["urlpayGet"] = 0;

		return new Promise((resolve, reject) => {
			let postData = {
				url: config.paycenter + url + '?' + qs.stringify(params),
				body: {},
				header: {}
			}
			AppRequire.post(postData).then(httpRequert => {
				if (window.debugFlag) {
					console.log(httpRequert)
				}
				let result = null;
				if (config.responseType == 'json') {
					//判定数据格式
					try {
						JSON.stringify(httpRequert);
						result = httpRequert;
					} catch (e) {
						config.utalkTools.logs("系统故障数据接口返回格式错误" + result, 'error');
						result = {
							errcode: 9876,
							errmsg: '数据格式错误! 请反馈给技术支持'
						};
					}
					//判定数据状态
					if (result && result.errcode && result.errcode == 1004) {
						if (config.requestCount["urlpayGet"] < 3) {
							config.requestCount["urlpayGet"]++;
							return new Promise((resolve, reject) => {
								Auth.login().then(result => {
									resolve(result);
								}).catch(error => {
									reject('设备错误! 要不更新一下软件试试呢!');
									config.utalkTools.logs('设备接口返回错误' + error, 'error');
								});
							}).then(result => {
								return new Promise((resolve, reject) => {
									appPay.get(url, params).then(result => {
										config.requestCount["urlpayGet"] = 0;
										resolve(result);
									}).catch(error => {
										reject(error);
									});
								});
							}).catch(error => {
								reject(error);
							});
						} else {
							config.requestCount["urlpayGet"] = 0;
							config.utalkTools.logs('设备接口返回错误 无法刷新登录 获取数据', 'error');
							reject('设备错误! 要不清一下软件缓存试试呢!');
						}
					} else if (result) {
						resolve(result);
					}
				} else {
					result = httpRequert;
				}
				resolve(result);
			}).catch(error => {
				if (config.requestCount["urlpayGet"] < 3) {
					config.requestCount["urlpayGet"]++;
					setTimeout(() => {
						appPay.get(url, params).then(result => {
							config.requestCount["urlpayGet"] = 0;
							resolve(result);
						}).catch(error => {
							reject(error);
						});
					}, 2000);
				} else {
					config.requestCount["urlpayGet"] = 0;
					config.utalkTools.logs('apprequest 程序捕获异常' + JSON.stringify(error), 'error');
					reject(error);
				}
				// config.utalkTools.logs('apprequest 程序捕获异常' + JSON.stringify(error), 'error');
				// reject(error);
			});
		});
	}
}